// ============================================================
// SILSILÄ — leaf cursor trail
// Scatters small botanical leaves along the pointer that drift,
// spin and fade. Self-contained (no deps), pointer devices only,
// disabled under reduced-motion.
// ============================================================
(function () {
  'use strict';
  if (document.body.dataset.leaf === 'false') return;               // theme setting
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  var canvas = document.createElement('canvas');
  canvas.setAttribute('aria-hidden', 'true');
  canvas.style.cssText = 'position:fixed;inset:0;width:100%;height:100%;pointer-events:none;z-index:9999';
  document.body.appendChild(canvas);
  var ctx = canvas.getContext('2d');
  var dpr = Math.min(window.devicePixelRatio || 1, 2);

  function resize() {
    canvas.width = innerWidth * dpr; canvas.height = innerHeight * dpr;
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
  }
  resize();
  addEventListener('resize', resize, { passive: true });

  // Leaf colour follows the time of day: the leaf is fully green at noon and
  // withers to terracotta by midnight, then greens back up through the morning.
  var GREEN = [44, 74, 58];    // #2C4A3A
  var TERRA = [197, 115, 79];  // #C5734F
  function timeMix() {
    var now = new Date();
    var h = now.getHours() + now.getMinutes() / 60;
    // smooth 24h cycle: green peak at 12pm (mix 0), terracotta peak at 12am (mix 1)
    return (1 + Math.cos(Math.PI * h / 12)) / 2; // 0 = green, 1 = terracotta
  }
  function leafColor() {
    var m = timeMix() + (Math.random() - 0.5) * 0.22; // gentle per-leaf variation
    if (m < 0) m = 0; else if (m > 1) m = 1;
    var r = Math.round(GREEN[0] + (TERRA[0] - GREEN[0]) * m);
    var g = Math.round(GREEN[1] + (TERRA[1] - GREEN[1]) * m);
    var b = Math.round(GREEN[2] + (TERRA[2] - GREEN[2]) * m);
    return 'rgb(' + r + ',' + g + ',' + b + ')';
  }
  var leaves = [];
  var lastX = 0, lastY = 0, lastSpawn = 0;

  function spawn(x, y, vx, vy) {
    leaves.push({
      x: x, y: y,
      vx: vx * 0.08 + (Math.random() - 0.5) * 0.7,
      vy: vy * 0.08 + (Math.random() - 0.5) * 0.7 + 0.4, // gentle downward drift
      rot: Math.random() * Math.PI * 2,
      vr: (Math.random() - 0.5) * 0.14,
      size: 5 + Math.random() * 7,
      life: 1,
      decay: 0.008 + Math.random() * 0.010,
      color: leafColor(),
      sway: Math.random() * Math.PI * 2,
    });
    if (leaves.length > 140) leaves.splice(0, leaves.length - 140);
  }

  addEventListener('pointermove', function (e) {
    var now = performance.now();
    var dx = e.clientX - lastX, dy = e.clientY - lastY;
    var dist = Math.hypot(dx, dy);
    // spawn based on movement so fast moves leave a denser trail
    if (now - lastSpawn > 22 && dist > 3) {
      spawn(e.clientX, e.clientY, dx, dy);
      if (dist > 34) spawn(e.clientX, e.clientY, dx, dy);
      lastSpawn = now;
    }
    lastX = e.clientX; lastY = e.clientY;
  }, { passive: true });

  function drawLeaf(l) {
    ctx.save();
    ctx.translate(l.x, l.y);
    ctx.rotate(l.rot);
    ctx.globalAlpha = Math.max(0, l.life) * 0.9;
    ctx.fillStyle = l.color;
    var s = l.size;
    ctx.beginPath();
    ctx.moveTo(0, -s);
    ctx.quadraticCurveTo(s * 0.85, 0, 0, s);
    ctx.quadraticCurveTo(-s * 0.85, 0, 0, -s);
    ctx.fill();
    // midrib
    ctx.globalAlpha *= 0.5;
    ctx.strokeStyle = 'rgba(255,255,255,.4)';
    ctx.lineWidth = 0.8;
    ctx.beginPath();
    ctx.moveTo(0, -s * 0.8); ctx.lineTo(0, s * 0.8);
    ctx.stroke();
    ctx.restore();
  }

  function frame() {
    ctx.clearRect(0, 0, innerWidth, innerHeight);
    for (var i = leaves.length - 1; i >= 0; i--) {
      var l = leaves[i];
      l.sway += 0.05;
      l.x += l.vx + Math.sin(l.sway) * 0.3;
      l.y += l.vy;
      l.vy += 0.012;             // slight gravity
      l.vx *= 0.99;
      l.rot += l.vr;
      l.life -= l.decay;
      if (l.life <= 0) { leaves.splice(i, 1); continue; }
      drawLeaf(l);
    }
    requestAnimationFrame(frame);
  }
  frame();
})();
